"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_calendar__26(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7db0617-621f-48c7-8f76-5ac366d03e29",
    x1: 59.82,
    y1: 28.29,
    x2: 179.23,
    y2: 147.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "calendar-26-hi"), /*#__PURE__*/React.createElement("g", {
    id: "8fdc71bd-52a3-4d55-a1b6-2ce944530d19",
    "data-name": "calendar-26-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "74e4ebde-c525-4bc6-aa0b-0d5666ed1c78",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2df04fa5-cabf-434c-a903-6f7d87c8dbf6",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "362200d8-5015-4b46-806f-179429bbf509",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e6979912-616f-4d62-a835-5e73f9fad700",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "86df4eb8-9e77-4082-98db-79b773d3d512",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "755dc43d-edfa-4655-8424-c336019e6efb",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a2eded1d-6c1b-401e-b28e-7baee8093479",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V64H24Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,24H32a8,8,0,0,0-8,8V64H168V32A8,8,0,0,0,160,24ZM52,40a4,4,0,1,1,4-4A4,4,0,0,1,52,40Zm88,0a4,4,0,1,1,4-4A4,4,0,0,1,140,40Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 144,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,52,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,140,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "95d514e7-a7b6-4032-ae50-20674e26d47b",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,64.13l-123.33-.2h-20v.59L128.34,168H152a19,19,0,0,0,4.24-.37,16.3,16.3,0,0,0,8.52-5.64,15.86,15.86,0,0,0,3.39-9.81V64.79Z",
    transform: "translate(0 0)",
    opacity: 0.1,
    fill: "url(#f7db0617-621f-48c7-8f76-5ac366d03e29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.89,24.63A7.92,7.92,0,0,1,31.19,24,7.92,7.92,0,0,0,28.89,24.63Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.54,25.37a8.1,8.1,0,0,0-1.7,1.55A8.1,8.1,0,0,1,27.54,25.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "M59.56,137.46V134A15.6,15.6,0,0,1,61,126.54a27.05,27.05,0,0,1,5.46-6.38l7-6.38a71.07,71.07,0,0,0,6.58-6.62,13.36,13.36,0,0,0,2.67-4.47,14.19,14.19,0,0,0,.56-4q0-4.55-2.27-6.9a8.63,8.63,0,0,0-6.5-2.35,13.3,13.3,0,0,0-5.94,1.43A26.45,26.45,0,0,0,62,96l-3-4.54a32.46,32.46,0,0,1,5-4.23,18.64,18.64,0,0,1,5.5-2.63,21,21,0,0,1,5.7-.8,15.11,15.11,0,0,1,8.57,2.31,12.33,12.33,0,0,1,4.78,5.5,16.44,16.44,0,0,1,1.32,6.3,17.59,17.59,0,0,1-2.27,9,35.32,35.32,0,0,1-7.38,8.37L72.56,122a26.32,26.32,0,0,0-5.1,5.34A8.65,8.65,0,0,0,66.1,132h25v5.42Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.53,138.5a14.59,14.59,0,0,1-7.42-1.79A15.29,15.29,0,0,1,105,132a20.52,20.52,0,0,1-2.91-6.74,32.88,32.88,0,0,1-.92-7.77A44.13,44.13,0,0,1,103.38,103a31.1,31.1,0,0,1,6-10.64,22,22,0,0,1,8.89-6.18,32.58,32.58,0,0,1,11.36-1.87l1.2,4.78q-8.53,0-14.11,3.87t-7.89,13.2a18.1,18.1,0,0,1,4.31-2.15,15.07,15.07,0,0,1,4.94-.8,12.94,12.94,0,0,1,8.61,3,15.7,15.7,0,0,1,4.9,7.1A24.37,24.37,0,0,1,133,121a21,21,0,0,1-1.08,6.78,17.23,17.23,0,0,1-3.07,5.58,14.34,14.34,0,0,1-11.32,5.18Zm.08-5.34a8.11,8.11,0,0,0,5.54-2.07,9.84,9.84,0,0,0,3.11-4.9,19.85,19.85,0,0,0,.76-5.06,15.5,15.5,0,0,0-1.44-6.86,9.24,9.24,0,0,0-3.87-4.27,10.08,10.08,0,0,0-4.82-1.32,13.84,13.84,0,0,0-4.94.88,15.74,15.74,0,0,0-4.15,2.31,33.35,33.35,0,0,0-.4,5.58,31.64,31.64,0,0,0,.48,5.34,17.43,17.43,0,0,0,1.67,5.1,11,11,0,0,0,3.15,3.79A7.9,7.9,0,0,0,117.61,133.15Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })));
}

var _default = ic_calendar__26;
exports.default = _default;